<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleDateChange="handleDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
            </div>
        </div>
        
        <Table
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:operate>
                <a-button type="primary" size="mini" v-permission="'setting.financial.enterPayable'" @click="handle('create')">
                    <icon-plus-circle size="13" style="marginRight:5px;"/>
                    {{ $t('financial.enterAccount') }}
                </a-button>
            </template>

            <template v-slot:tableOperate="{ props }">
                <a-button type="primary" size="mini" v-permission="'setting.financial.editPayable'" @click="handle('edit', props.record)">
                    <icon-edit size="13" style="marginRight:5px;" />
                    {{ $t('base.edit') }}
                </a-button>
            </template>

        </Table>

        <!-- 新建目标 -->
        <a-modal
            v-model:visible="visible" 
            draggable
            :onBeforeOk="onBeforeOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('financial.enterAccount') }}</div>
            </template>
            
            <Form
                :form="addForm"
                @handleInputNumberChange="handleInputNumberChange"
            ></Form>
        </a-modal>
        
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch } from 'vue';
    import { FinancialApi } from '@/api/FinancialApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { AccountQueryForm, AddAccountForm } from './queryConfig/FinancialQuery'
    import { dateToTimestamp, timestampToDate} from '@/utils/index.js';
    import { multiply, add, subtract, divide } from 'accurate-core';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n()

    const queryForm = reactive(AccountQueryForm)
    const addForm = reactive(AddAccountForm)
    const visible = ref(false)
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                align:'left',
            },
            {
                // title: '日期',
                title:t('financial.recordTimestamp'),
                dataIndex: 'record_timestamp',
                key:'record_timestamp',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },  
            {
                // title: '应付',
                title:t('financial.account'),
                dataIndex: 'amount_out',
                key:'amount_out',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '操作',
                title:t('order.operate'),
                dataIndex: 'Optional',
                key: 'Optional',
                slotName: 'optional',
                width: '260',
                align: 'center',
                fixed: 'right'
            }   
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })

    const handle = (type, row)=>{
        switch(type){
            case 'search':
                cashAndAccountList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                break;
            case 'create':
                addForm.formField.forEach(item=>{
                    addForm.formData[item.key] = ''
                    if(item.key == 'record_timestamp'){
                        item.disabled = false
                    }
                })
                visible.value = true
                break;
            case 'edit':
                addForm.formField.forEach(item=>{
                    if(item.key == 'record_timestamp'){
                        item.disabled = true
                    }
                    if(item.key == 'amount_out'){
                        addForm.formData[item.key] = Number(row[item.key].toString().replace('-',' ').trim())
                    }else{
                        addForm.formData[item.key] = row[item.key]
                    }
                })
                addForm.formData.id = row.id
                visible.value = true    
                break;
        }
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        cashAndAccountList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        cashAndAccountList()
    }

    const handleSelectChange = ()=>{
        table.value.configs.pagination.current = 1
        cashAndAccountList()
    }

    const handleDateChange = ()=>{
        table.value.configs.pagination.current = 1
        cashAndAccountList()
    }

    const handleInputNumberChange = (item,val,inputVal)=>{
        // console.log(item,val,inputVal,'item,val,inputVal')
        if(addForm.formData.amount_in !== '' && addForm.formData.amount_out !== ''){
            addForm.formData.amount_total = subtract(addForm.formData.amount_in, addForm.formData.amount_out)
        }
    }

    const cashAndAccountList = async ()=>{
        console.log(queryForm.formData.record_timestamp,'kkk')
        let param = {
            model:'ACCOUNTS',
        }
        if(queryForm.formData.record_date !== '') param.record_date = queryForm.formData.record_date

        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await FinancialApi.getInstance().cashAndAccountList(param, page_num, page_size)
        if(res.code == 0){
            res.data.records.forEach((item, index)=>{
                item.No = index + 1
                item.record_timestamp = timestampToDate(item.record_timestamp * 1000).split(' ')[0]
                item.amount_out = item.amount_out === 0? '€ ' + 0 : item.amount_out.toString().indexOf('-') > -1? `€ ${item.amount_out}` : `€ -${item.amount_out}`
            })
            table.value.datas = res.data.records
            table.value.configs.loading = false
            table.value.configs.pagination.total = res.data.total
        }else{
            Message.error(res.msg)
        }
    }

    const onBeforeOk = async ()=>{
        if(!addForm.formData.record_timestamp){
            Message.error(t('financial.recordTimestamp') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm.formData.amount_out === ''){
            Message.error(t('financial.account') + ' ' + t('base.noEmpty'))
            return false
        }

        let param = {
            model:'ACCOUNTS',   
            ...addForm.formData,
            amount_out:addForm.formData.amount_out.toString().indexOf('-') > -1? addForm.formData.amount_out : Number(`-${addForm.formData.amount_out}`),
            amount_in:0,
            amount_total: addForm.formData.amount_out.toString().indexOf('-') > -1? addForm.formData.amount_out : Number(`-${addForm.formData.amount_out}`),
            record_timestamp: dateToTimestamp(addForm.formData.record_timestamp)
        }
        console.log(param,'param')
        let res = await FinancialApi.getInstance().saveCashAndAccount([param])
        if(res.code == 0){
            Message.success(t('base.createSuccess'))
            cashAndAccountList()
        }else{
            Message.error(res.msg)
        }
    }

    onMounted(()=>{
        cashAndAccountList()
    })

</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 0px 0;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}
</style>